import { makeAsyncCard as _makeAsyncCard, makeAsyncTitle as _makeAsyncTitle
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module  Remove this comment to see the full error message
} from 'customer-data-sidebar/async';
import CardContentLoadingComponent from 'crm-cards-sdk/components/skeletons/CardContentLoadingComponent';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
export function makeAsyncCard(options) {
  return _makeAsyncCard(options, CardContentLoadingComponent);
}
function TitleLoadingComponent({
  renderLoadingIndicator
}) {
  if (renderLoadingIndicator) {
    return renderLoadingIndicator();
  }
  return /*#__PURE__*/_jsx(TFlex, {
    justify: "start",
    children: /*#__PURE__*/_jsx(LoadingSpinner, {
      size: "xs"
    })
  });
}
export function makeAsyncTitle(options) {
  return _makeAsyncTitle(options, TitleLoadingComponent);
}